import React, { useState } from 'react';
import CalculatedField from '../CalculatedField';
import Icon from '../../../Icon';

export default function TwoColumnSection({
  section,
  data,
  onReportClick = () => {},
}) {
  let [exportingLeft, setExportingLeft] = useState(false);
  let [exportingRight, setExportingRight] = useState(false);
  const { leftSchema, rightSchema } = section;
  const {
    sectionLabel: leftLabel,
    sectionSubLabel: leftSubLabel,
    schema: leftFields,
    percentageValue: percentageLeft,
    annualValue: annualLeft,
  } = leftSchema;
  const {
    sectionLabel: rightLabel,
    sectionSubLabel: rightSubLabel,
    schema: rightFields,
    percentageValue: percentageRight,
    annualValue: annualRight,
  } = rightSchema;

  const leftDropDownFields = leftFields?.filter((field) => field.dropDown);
  const rightDropDownFields = rightFields?.filter((field) => field.dropDown);

  const initLeftDropDowns = !leftDropDownFields?.length
    ? null
    : leftDropDownFields.reduce((acc, field) => {
        acc[field.name] = false;
        return acc;
      }, {});

  const initRightDropDowns = !rightDropDownFields?.length
    ? null
    : rightDropDownFields.reduce((acc, field) => {
        acc[field.name] = false;
        return acc;
      }, {});

  const [leftDropDowns, setLeftDropDowns] = useState(initLeftDropDowns);
  const [rightDropDowns, setRightDropDowns] = useState(initRightDropDowns);

  const handleLeftDropDown = (name) => {
    setLeftDropDowns((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const handleRightDropDown = (name) => {
    setRightDropDowns((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  return (
    <>
      <div className="grid sm:grid-cols-2 gap-6">
        <section className="rounded-lg relative bg-white">
          <div
            className="py-4 px-6 border-b border-neutral-100 flex items-center gap-3"
            id={leftLabel.replaceAll(' ', '-').toLowerCase()}
          >
            <h3 className="text-lg font-medium font-serif text-neutral-900">
              <span className="py-1 ">{leftLabel}</span>
              {leftSubLabel && (
                <span className="pr-1 text-base text-neutral-500">
                  {leftSubLabel}
                </span>
              )}

              {leftSchema.reportButton && (
                <button
                  onClick={() => {
                    setTimeout(() => {
                      setExportingLeft(true);
                    }, 0);
                    onReportClick(leftLabel.reportButton);
                    setTimeout(() => {
                      setExportingLeft(false);
                    }, 500);
                  }}
                  type="button"
                  className="rounded-md bg-white px-2 py-1 text-sm font-semibold text-neutral-900 ring-1 ring-inset ring-neutral-200 hover:bg-gray-50"
                >
                  Export
                </button>
              )}
            </h3>
          </div>
          <div className="px-6 pb-8 pt-4">
            <ul className="">
              {leftFields?.map((field, index) => (
                <li className="" key={`${field.name} ${index}`}>
                  <CalculatedField
                    showTopBorder={index > 0}
                    field={field}
                    fieldValue={data[field.name]}
                    sectionType="twoColumn"
                    data={data}
                    percentageValue={percentageLeft}
                    annualValue={annualLeft}
                    dropDowns={leftDropDowns}
                    handleDropDown={
                      leftDropDownFields?.find((el) => el.name === field.name)
                        ? handleLeftDropDown
                        : null
                    }
                    showBar={field.showBar ?? false}
                  />
                </li>
              ))}
            </ul>
          </div>
        </section>
        <section
          className="rounded-lg relative bg-white"
          id={rightLabel.replaceAll(' ', '-').toLowerCase()}
        >
          <div className="py-4 px-6 border-b border-neutral-100 flex items-center gap-3 justify-between">
            <h3 className="text-lg font-medium font-serif text-neutral-900">
              <span>{rightLabel}</span>
            </h3>

            {rightSubLabel && (
              <span className="font-medium text-sm text-neutral-500">
                {rightSubLabel}
              </span>
            )}

            {rightSchema.reportButton && (
              <button
                onClick={() => {
                  setTimeout(() => {
                    setExportingRight(true);
                  }, 0);
                  onReportClick(leftLabel.reportButton);
                  setTimeout(() => {
                    setExportingRight(false);
                  }, 500);
                }}
                type="button"
                className="rounded-md bg-white px-2 py-1 text-sm font-semibold text-neutral-900 ring-1 ring-inset ring-neutral-200 hover:bg-gray-50"
              >
                {exportingRight ? (
                  <Icon
                    icon="BiLoaderAlt"
                    className="text-xl animate-spin h-5 w-5"
                  ></Icon>
                ) : (
                  <span>Export</span>
                )}
              </button>
            )}
          </div>
          <div className="px-6 pb-8 pt-4">
            <ul className="">
              {rightFields?.map((field, index) => (
                <li className="" key={`${field.name} ${index}`}>
                  <CalculatedField
                    showTopBorder={index > 0}
                    field={field}
                    fieldValue={data[field.name]}
                    sectionType="twoColumn"
                    data={data}
                    percentageValue={percentageRight}
                    annualValue={annualRight}
                    dropDowns={rightDropDowns}
                    handleDropDown={
                      rightDropDownFields?.find((el) => el.name === field.name)
                        ? handleRightDropDown
                        : null
                    }
                  />
                </li>
              ))}
            </ul>
          </div>
        </section>
      </div>
    </>
  );
}
